module.exports = __webpack_public_path__ + "static/media/CM Foundation Stone without shdow.468c069a.svg";